import { STARS_ACCOUNT_TYPE_ENUM } from '@core/enums/stars-account-type.enum';

export const StarsAccountTypesValue = [
  STARS_ACCOUNT_TYPE_ENUM.STARS,
  STARS_ACCOUNT_TYPE_ENUM.STARS_PROVIDER_ADMIN,
  STARS_ACCOUNT_TYPE_ENUM.REFERRAL_PROGRAM_PROVIDER_ADMIN
];
